import * as React from "react";
import {
    List,
    Datagrid,
    TextField,
    EditButton,
    Edit,
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    DateField,
    ReferenceField,
    ReferenceInput,
    SelectField
} from 'react-admin';

export const DemandList = props => (
    <List {...props}>
        <Datagrid rowClick="edit">
            <TextField source="id" />
            <TextField source="Title" label="标题" />
            <TextField source="RequesterName" label="发布人" />
            <SelectField source="Status" label="状态" choices={[
                { id: 0, name: '待认领' },
                { id: 1, name: '已认领' },
                { id: 2, name: '已完成' },
            ]} />
            <ReferenceField source="ClaimerId" reference="PartyMember" label="认领人">
                <TextField source="Name" />
            </ReferenceField>
            <DateField source="CreateTime" label="发布时间" />
            <EditButton />
        </Datagrid>
    </List>
);

export const DemandEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput disabled source="id" />
            <TextInput source="Title" label="标题" />
            <TextInput multiline source="Content" label="内容" />
            <TextInput source="RequesterName" label="发布人" />
            <TextInput source="RequesterPhone" label="联系电话" />
            <TextInput source="Location" label="位置" />
            <SelectInput source="Status" label="状态" choices={[
                { id: 0, name: '待认领' },
                { id: 1, name: '已认领' },
                { id: 2, name: '已完成' },
            ]} />
            <ReferenceInput source="ClaimerId" reference="PartyBuilding/PartyMember" label="认领人">
                <SelectInput optionText="Name" />
            </ReferenceInput>
            <TextInput multiline source="Feedback" label="反馈结果" />
        </SimpleForm>
    </Edit>
);

export const DemandCreate = props => (
    <Create {...props}>
        <SimpleForm>
            <TextInput source="Title" label="标题" />
            <TextInput multiline source="Content" label="内容" />
            <TextInput source="RequesterName" label="发布人" />
            <TextInput source="RequesterPhone" label="联系电话" />
            <TextInput source="Location" label="位置" />
            <SelectInput source="Status" label="状态" initialValue={0} choices={[
                { id: 0, name: '待认领' },
                { id: 1, name: '已认领' },
                { id: 2, name: '已完成' },
            ]} />
        </SimpleForm>
    </Create>
);
